import { Injectable } from "@angular/core";
import { Section } from "app/client/section/section";
import { ClientsService } from "../client/ClientsService";

@Injectable()
export class AssessmentManagerService{
    sections: Section[] = [];
    currentSection: number = 0;

    assessmentSections: number;
    assesmentId:number;

    sectionsJsonData: any;
    assessmentLoaded: boolean = false;
    questionsTotal: number = 0;
    

    constructor(
        private _ClientsService: ClientsService)
    {
        
    }

    loadAssessment()
    { 
        //getAssessmentSections
        this._ClientsService. getAssessmentSections(this.assesmentId)
            .subscribe(res =>
            {
                this.currentSection = 0;
                this.sectionsJsonData = res.result;
                this.loadNextSection();
                /*this.currentSection--;
                let arrayIndex = this.currentSection;
                this.currentSection = res.result[arrayIndex].SectionId;
                this.assessmentSections = res.result.length;

                let sectionId = res.result[arrayIndex].SectionId;
                let singleChoice = res.result[arrayIndex].SingleChoice;
                let showIcons = res.result[arrayIndex].ShowIcons;

                this.section = new Section(sectionId, this.assesmentId, singleChoice, showIcons, this.getAssessmentSectionQuestions, this.getSectionChoices, this.getQuestionChoices );*/
                //this.showSection();
            });
    }

    loadNextSection() {
        console.log('assessment manager service');
        let section: Section;
        
        let sectionId = this.sectionsJsonData[this.currentSection].SectionId;
        let singleChoice = this.sectionsJsonData[this.currentSection].SingleChoice;
        let showIcons = this.sectionsJsonData[this.currentSection].ShowIcons;
        let displayMode = this.sectionsJsonData[this.currentSection].DisplayMode;

        if (!singleChoice) 
        {
            var totalForNonsingleChoice = this.getCurrentQuestionForNonSingleChoice();
        }

        section = new Section(sectionId, this.assesmentId, singleChoice, showIcons, displayMode, this._ClientsService);
        section.sectionLoadedEvent.subscribe(
            (data: any) => {
                this.sectionLoaded();
            });

        this.sections.push(section);

        section.load();

    }

    getCurrentQuestionForNonSingleChoice(): number {
        console.log('getCurrentQuestionForNonSingleChoice');
        let total = 0;
        for (var i = 0; i < this.sections.length; i++) {
            total += this.sections[i].questions.length;
        }
        return total;
    }

    sectionLoaded() {

        this.currentSection++;

        if (this.currentSection < this.sectionsJsonData.length)
        {
            console.log('if Sections', this.sections);
            this.loadNextSection();
        }
        else {
            console.log('else Sections', this.sections);
            this.currentSection = 0;
            this.assessmentLoaded = true;
            this.getTotalQuestions();
        }

    }

    nextSection()
    {
        this.currentSection++;
        this.loadAssessment();
    }

    getTotalQuestions() {
        for (var i = 0; i < this.sections.length; i++) {
            this.questionsTotal += this.sections[i].questions.length;
        }
    }

    
}

